export const isValidHttpUrl = (urlString: string) => {
  let url;

  if (!urlString) return true;

  try {
    url = new URL(urlString);
  } catch {
    return false;
  }

  return url.protocol === "http:" || url.protocol === "https:";
};

export const isValidUrl = (urlString: string) => {
  try {
    new URL(urlString);
    return true;
  } catch {
    return false;
  }
};

export const buildSystemTreeUrl = (systemId: string, configId: string, snapshotId: string, pathId?: string): string => {
  const base = `/systems/${systemId}/${configId}/${snapshotId}/tree`;
  return pathId ? `${base}/${pathId}` : base;
};
